

import { ITEMS_PER_PAGE as ITEMS_PER_PAGE_RESOURCE } from '../resources/config';
import { ITEMS_PER_PAGE as ITEMS_PER_PAGE_EVENT } from '../events/config';

export const DESKTOP_ITEMS_PER_PAGE = {
  organizations: 5,
  resources: ITEMS_PER_PAGE_RESOURCE,
  events: ITEMS_PER_PAGE_EVENT,
  blogs: 6,
  programs: 6,
}
